import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  workOrderType: null,
  workOrderTypeList: [],
};

const route = "modules/settings/views/workOrderType/modals/deleteManageWorkOrderType/redux/slice";

export const manageDeleteManageWorkOrderType = createAsyncThunk("manage/deleteManageWorkOrderType/bulkDeleteWorkOrderType", async (payload, { rejectWithValue }) => {
  try {
    const response = await clientMutation(
      `mutation bulkDeleteWorkOrderType ($ids: [Int!]) {
        result: bulkDeleteWorkOrderType (ids: $ids)
      }`,
      payload,
      endpoints.GRAPHQL_GENERAL_V2
    );

    return { delete: response?.result }

  } catch (exc) {
    ExceptionManager(exc, route, "bulkDeleteWorkOrderType");
    return rejectWithValue(exc);
  }
}
);


const manageDeleteManageWorkOrderTypeRedux = createSlice({
  name: "manage/deleteManageWorkOrderType",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    },
    openModalDeleteWorkOrderType(state, action) {
      state.open = true;
      state.workOrderType = action?.payload?.workOrderType;
      state.workOrderTypeList = action?.payload?.workOrderTypeList;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageDeleteManageWorkOrderType
    builder.addCase(manageDeleteManageWorkOrderType.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageDeleteManageWorkOrderType.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(manageDeleteManageWorkOrderType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageDeleteManageWorkOrderTypeRedux;

// Extract and export each action creator by name
export const { reset, openModalDeleteWorkOrderType } = actions;

// Export the reducer, either as a default or named export
export default reducer;